import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '@shared/services/base.service';
import { firstValueFrom } from 'rxjs';
import { MongoNoteDetail, MongoNoteWithTicketStatus } from './h-notes.models';

@Injectable({
  providedIn: 'root',
})
export class HNotesService {
  private readonly baseUrl: string;

  constructor(
    private http: HttpClient,
    private baseService: BaseService
  ) {
    this.baseUrl = this.baseService.getBaseUrl();
  }

  async getNotes(objectId: string, noteTypeId?: string): Promise<MongoNoteDetail[]> {
    const url = `${this.baseUrl}/MongoNotes/getNotes/${objectId}`;
    const params = noteTypeId ? { noteTypeId } : {};
    return firstValueFrom(this.http.get<MongoNoteDetail[]>(url, { params }));
  }

  async getNotesWithTicketStatus(ticketId: string): Promise<MongoNoteWithTicketStatus[]> {
    const url = `${this.baseUrl}/MongoNotes/getNotesWithTicketStatus/${ticketId}`;
    return firstValueFrom(this.http.get<MongoNoteWithTicketStatus[]>(url));
  }
}
